<template>
  <modal
    v-if="modalVisible"
    :heightOfScroll="heightOfScroll"
    class="report"
    :largeModal="true"
    :title="title"
    :paddingWithScroll="'20px'"
    width="70%"
    @close="closeModal">
    <template v-slot:body>
      <TrialClass
        v-if="reportType === 'tc'"
        :mcReportElement="mcReportElement"
        :mcReportFields="mcReportFields"
        :showSelect="showSelect"
        @eventOnSelect="eventOnSelect"
        @eventOnInput="eventOnInput"
        @eventOnCheckbox="eventOnCheckbox"
      />
    </template>
    <template v-slot:footer>
      <div class="flex-end w-100">
        <button @click="closeModal" class="btn btn--transparent btn_cancel report__btn_cancel">
          {{$t('mc.mimk.mcReport.button.cancel')}}
        </button>
        <div @click="disabledButtonUserAttention" class="report-button_wrapper">
          <button
            @click="sendReport"
            :disabled="!showSendButton"
            class="btn btn_blue report-button">
            <div
              class="report-button__tooltip"
            />
            {{$t('mc.mimk.mcReport.button.send')}}
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import apiMimk from '@/api/master-classes/mimk'
import TrialClass from "@/components/Mimk/Reports/TrialClass";

export default {
  data() {
    return {
      orderId: null,
      comment: null,
      studentGroup: '',
      showSelect: true,
      modalVisible: false,
      showSendButton: false,
      reportType: '',
      fetchFilesData: null,
      mcReportElement: {},
      mcReportFields: {},
      mandatoryFields: {
        backoffice_courses: [],
        string: [],
        choice: [],
        many_choice: [],
        datetime: [],
      },
      mandatoryCompareFields: {
        backoffice_courses: new Set(),
        string: new Set(),
        choice: new Set(),
        datetime: new Set(),
        many_choice: new Set(),
      },
      resultOfCompare: {
        backoffice_courses: false,
        string: false,
        choice: false,
        datetime: false,
        many_choice: false,
      },
    }
  },
  components: {
    TrialClass
  },
  computed: {
    heightOfScroll() {
      return this.reportType === 'tc' ? 600 : 600
    },
    title() {
      return this.$t('mc.mimk.mcReport.title')
    }
  },
  methods: {
    disabledButtonUserAttention() {
      if (!this.showSendButton) this.$toasted.global.all_mistake('Заполните все обязательные поля')
    },
    callModal(typeOfModal, emitArg, element) {
      this.reportType = typeOfModal
      this.modalVisible = true
      this.mcReportElement = element
      let getFieldsInfoByLS = JSON.parse(localStorage.getItem(`${this.reportType}-report-${element.id}`))
      let getFieldsInfoByEmitArg = JSON.parse(JSON.stringify(emitArg))
      if (typeOfModal === 'tc') {
        this.mutateTcReportFields(getFieldsInfoByLS, getFieldsInfoByEmitArg)
      }
    },
    mutateTcReportFields(receivedDataByLs, receivedDataByRequest) {
      for (const emitEl in receivedDataByRequest) {
        receivedDataByRequest[emitEl].forEach((el, i) => {
          if (el.answer_type === 'choice' || el.answer_type === 'string' || el.answer_type === 'datetime' || el.answer_type === 'many_choice') {
            if (el.mandatory) this.mandatoryFields[el.answer_type].push(i)
            if (!receivedDataByLs) el.answer = ''
          }else {
            if (!receivedDataByLs) el.answer = false
          }
        })

        if (receivedDataByLs) {
          for (const lsEl in receivedDataByLs) {
            receivedDataByRequest[emitEl].forEach(emitDeep => {
              receivedDataByLs[lsEl].forEach(lSDeep => {
                if (emitDeep.question === lSDeep.question) {
                  emitDeep.answer = lSDeep.answer
                }
              })
            })
          }
        }
      }
      this.mcReportFields = receivedDataByRequest
      if (receivedDataByLs) {
        this.validateAll()
      }
    },
    validateAll() {
      this.compareToMandatory('choice')
      this.compareToMandatory('backoffice_courses')
      this.compareToMandatory('string')
      this.compareToMandatory('many_choice')
      this.compareToMandatory('datetime')
    },
    compareToMandatory(mondatoryObjectField) {
      const equals = (a, b) => a.length === b.length && a.every((v, i) => v === b[i])
      for (const item in this.mcReportFields) {
        if (item === 'string' || item === 'choice' || item === 'many_choice' || item === 'datetime' || item === 'backoffice_courses') {
          if (!this.mcReportFields[mondatoryObjectField]) continue
          this.mcReportFields[mondatoryObjectField].forEach((el, idx) => {
            let hasAnswer = false;

            if (mondatoryObjectField === 'backoffice_courses') {
              hasAnswer = Array.isArray(el.answer) && el.answer.length > 0;
            } else if (mondatoryObjectField === 'string') {
              hasAnswer = el.answer.toString().length > 0;
            } else {
              hasAnswer = el.answer.toString().length > 0;
            }

            if (hasAnswer) {
              this.mandatoryCompareFields[mondatoryObjectField].add(idx)
            } else if (mondatoryObjectField === 'string') {
              this.mandatoryCompareFields[mondatoryObjectField].delete(idx)
            }
          })
        }
      }
      let sortFillInFields = [...this.mandatoryCompareFields[mondatoryObjectField]].sort((a, b) => a - b)
      let compareArray = []
      if ((sortFillInFields.length - this.mandatoryFields[mondatoryObjectField].length) >= 0) {
      this.mandatoryFields[mondatoryObjectField].forEach(elDataF => {
        sortFillInFields.forEach(elComp => {
          if (elComp == elDataF) compareArray.push(elComp)
        })
      })
      }
      if (equals(this.mandatoryFields[mondatoryObjectField], compareArray)) this.resultOfCompare[mondatoryObjectField] = true
      else this.resultOfCompare[mondatoryObjectField] = false

      this.resultOfCompare.datetime && this.resultOfCompare.string && this.resultOfCompare.choice && this.resultOfCompare.many_choice && this.resultOfCompare.backoffice_courses ? this.showSendButton = true : this.showSendButton = false
      sortFillInFields = []
    },
    // eventOnSelect(type) {
    eventOnSelect() {
        // this.compareToMandatory(type)
      this.validateAll()
        // this.showSelect = false
        // this.$nextTick(() => {
        //   this.showSelect = true
        // })
      this.reportSetLocalStorage()
    },
    eventOnInput() {
      if (this.reportType === 'tc') {
        // this.compareToMandatory('string')
        this.validateAll()
      }
      this.reportSetLocalStorage()
    },
    eventOnCheckbox(index) {
      let payloadToBooelan =  typeof this.mcReportFields.boolean[index] === 'string' ?
        !!this.mcReportFields.boolean[index].answer :
        this.mcReportFields.boolean[index].answer
      payloadToBooelan = !payloadToBooelan
      this.mcReportFields.boolean[index].answer = payloadToBooelan
      this.validateAll()
      this.reportSetLocalStorage()
    },
     async sendReport() {
      let response = false
      if (this.reportType === 'tc') {
        let sendArray = []
        if (this.reportType) {
          for (const item in this.mcReportFields) {
            if (Array.isArray(this.mcReportFields[item])) {
                let arrayElement = this.mcReportFields[item].map(el => {
                  let {answer, question} = el;
                  let processedAnswer = answer;
                  if (item === 'backoffice_courses' && Array.isArray(answer)) {
                    processedAnswer = answer.map(course => course.text || course.title || course.name).join(', ');
                  } else if (Array.isArray(answer)) {
                    processedAnswer = answer.join(', ');
                  }

                  const data = {answer: processedAnswer, question}
                  if (el.field_in_letter) {
                    data.field_in_letter = el.field_in_letter
                  }
                  return data
              })
              sendArray.push(...arrayElement)
            }
          }
          sendArray = sendArray.filter(el =>
            (typeof el.answer === 'string' && el.answer.length > 0)
            || typeof el.answer === 'number'
            || typeof el.answer === 'boolean')
        }
        const sendingData = {
          data: [...sendArray],
          booking_id: this.mcReportElement.id,
          amocrm_id: this.mcReportElement.extraInformation.amoLink,
          backoffice_id: this.mcReportElement.extraInformation.backofficeLink || null,
          segment: this.mcReportElement.extraInformation.segment,
          mimk_id: this.$store.state.user.user.id,
        }
        this.$emit('changeLoader', true)
        response = await apiMimk.sendTcReport(sendingData)
        this.closeModal()
        localStorage.removeItem(`${this.reportType}-report-${this.mcReportElement.id}`)
        this.$emit('changeLoader', false)
      }
      if (response){
        this.$toasted.global.all_ok(this.$t("mc.mimk.report.toastSuccess"))
        this.closeModal()
      }else {
        this.$toasted.global.all_mistake(this.$t("mc.mimk.report.toastWrong"))
      }
     },
    reportSetLocalStorage() {
      let LSObject = this.mcReportFields
      localStorage.setItem(`${this.reportType}-report-${this.mcReportElement.id}`, JSON.stringify(LSObject))
    },
    closeModal() {
      this.mandatoryFields = {
        backoffice_courses: [],
        string: [],
        choice: [],
        many_choice: [],
        datetime: [],
      }
      this.showSendButton = false
      this.modalVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>

.report {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  &-fields{
    &:first-child {
      width: 65%;
    }
    &:last-child {
      width: 35%;
    }
  }
  &-checkboxes {
    display: inline-grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 10px;
  }
  &__bold-text {
    font-weight: 700;
  }
  &__radio-block {
    margin-top: 8px;
  }
  &__choise {
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
  }
  &__radio {
    &:first-child {
      margin-right: 30px;
    }
  }
  &-checkbox {
    margin: 20px auto;
  }
  &-button{
    min-width: 200px;
    max-width: 200px;
    position: relative;
    &__tooltip {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  &__radio-block {
    margin-bottom: 20px;
  }

  &-inputs {
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
    &__radios {
      margin-top: 10px;
      display: flex;
    }
    &__radio {
      &:first-child{
        margin-right: 20px;
      }
    }
  }
  &__input-text {
    margin-top: 8px;
  }
  &__select {
    border: 1px solid transparent;
    margin-top: 8px;
    margin-bottom: 25px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &-fields {
    width: 100%;
    &:first-child {
      margin-right: 60px;
    }
  }
  &__btn_cancel {
    background: #F1F1F5;
    max-width: 130px;
    min-width: 130px;
    margin-right: 20px;
  }
}
</style>



